import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.split.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.array.find.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import map from 'lodash/map';
import { stringify, parse } from 'qs';
import { LOCALES } from '~/const/i18n';
import { CATEGORY_INFIX, PRODUCT_INFIX } from '~/const/infix';
import { capitalize } from '~/helpers/user-helper';
var PRODUCTS_PER_PAGE = 40;

var buildEditorialCanonical = function buildEditorialCanonical(base, path, page) {
  return {
    rel: 'canonical',
    href: "".concat(base).concat(path).concat(page ? "?page =".concat(page) : '')
  };
};

var buildEditorialAlternates = function buildEditorialAlternates(base, type, slug) {
  var useAlias = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var noType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var currentSlug = slug ? "/".concat(slug) : '';
  var currentType = '';
  var trailingSlash = '';

  if (noType === false) {
    currentType = useAlias !== false ? "e/".concat(useAlias) : "e/".concat(type);
    trailingSlash = '/';
  }

  return map(LOCALES, function (locale) {
    return {
      rel: 'alternate',
      hreflang: locale.iso ? locale.iso.toLowerCase() : '',
      href: "".concat(base, "/").concat(locale.market, "/").concat(locale.language).concat(trailingSlash).concat(currentType).concat(currentSlug)
    };
  });
};

var buildUrl = function buildUrl(urlbaseArray) {
  var queryString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var currentPath = urlbaseArray.join('/');
  var queryParams = queryString ? "?".concat(queryString) : '';
  var queryExtension = extension ? "".concat(extension) : '';
  return "".concat(currentPath).concat(queryExtension).concat(queryParams);
};

var buildCategoryNextLink = function buildCategoryNextLink(locale, base, alias, total, pagination) {
  var facet = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var predicate = total - pagination * PRODUCTS_PER_PAGE; // Current facet value is already a query param

  var facetParsed = parse(facet);
  var page = pagination + 1;
  var queryString = stringify(_objectSpread(_objectSpread({}, predicate > 0 && {
    page: page
  }), predicate > 0 && facetParsed));
  return predicate > 0 ? {
    rel: 'next',
    href: buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, alias], queryString)
  } : null;
};

var buildCategoryPrevLink = function buildCategoryPrevLink(locale, base, alias, pagination) {
  var facet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  // Current facet value is already a query param
  var facetParsed = parse(facet);
  var page = pagination - 1;
  var queryString = stringify(_objectSpread(_objectSpread({}, pagination > 2 && {
    page: page
  }), facetParsed));
  return pagination > 1 ? {
    rel: 'prev',
    href: buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, alias], queryString)
  } : null;
};

var buildCategoryCanonical = function buildCategoryCanonical(locale, base, alias, page, facet) {
  // Current facet value is already a query param
  var facetParsed = parse(facet);
  var queryString = stringify(_objectSpread(_objectSpread({}, page > 1 && {
    page: page
  }), facetParsed));
  return {
    rel: 'canonical',
    href: buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, alias], queryString)
  };
};

var buildMagazineLinks = function buildMagazineLinks(_ref) {
  var base = _ref.base,
      alias = _ref.alias,
      type = _ref.type,
      page = _ref.page;
  var queryString = stringify({
    page: page
  });
  return {
    rel: type,
    href: buildUrl([base, alias], queryString)
  };
};

var buildCategoryAlternates = function buildCategoryAlternates(base, aliases, hash, page) {
  var facet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var hreflang = arguments.length > 5 ? arguments[5] : undefined;
  var queryParams = arguments.length > 6 ? arguments[6] : undefined;
  // Current facet value is already a query param
  var facetParsed = parse(facet);
  var queryString = stringify(_objectSpread(_objectSpread({}, page > 1 && {
    page: page
  }), facetParsed));
  var hasQueryParams = !!Object.entries(queryParams || {}).find(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        val = _ref3[1];

    return key === 'page' && val !== '1' || ['page', 'order', 'sort'].indexOf(key) === -1;
  });

  var markets = function markets(locale) {
    return hreflang && hreflang.length !== 0 ? hreflang.find(function (lang) {
      return lang.market.toUpperCase() === locale.market;
    }) : LOCALES;
  };

  var locales = hasQueryParams ? [] : LOCALES.filter(function (locale) {
    return markets(locale);
  });
  return map(locales, function (locale) {
    return {
      rel: 'alternate',
      hreflang: locale.iso ? locale.iso.toLowerCase() : '',
      href: locale && locale.language && locale.market ? buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, "".concat(aliases[locale.language.toLowerCase()], "-").concat(hash)], queryString) : ''
    };
  });
};

var buildProductAlternates = function buildProductAlternates(isMarketplace, base, slugs, reference) {
  var locales = isMarketplace ? [LOCALES.find(function (item) {
    return item.market === 'FR';
  })] : LOCALES;
  return map(locales, function (locale) {
    return {
      rel: 'alternate',
      hreflang: locale.iso ? locale.iso.toLowerCase() : '',
      href: locale && locale.language && locale.market ? buildUrl([base, locale.market, locale.language, PRODUCT_INFIX, "".concat(slugs[locale.language.toLowerCase()], "-").concat(reference)], '', '.htm') : ''
    };
  });
};
/**
 * content square rule
 * content square id does not accept 4 coonsecutive number
 * @param {String} {id}
 * @returns {String}
 */


var transformToContentSquareId = function transformToContentSquareId(id) {
  if (!id) return '';
  var counter = 0;
  return id.split('').map(function (char) {
    if (Number(char) || Number(char) === 0) {
      counter += 1;
    } else {
      counter = 0;
    }

    if (counter === 4) {
      counter = 1;
      return "-".concat(char);
    }

    return char;
  }).join('');
};

var buildUniqueClassName = function buildUniqueClassName(prefix, label) {
  return "".concat(prefix, "-").concat(label.replace(/[ ,.]+/g, '-').toLowerCase());
};

var buildUniqueIdName = function buildUniqueIdName(prefix, label, id) {
  return transformToContentSquareId("".concat(prefix).concat(capitalize((label || '').split(/[\s,.]+/).map(capitalize).join(''))).concat(capitalize(id || '')));
};

export { buildEditorialCanonical, buildEditorialAlternates, buildCategoryNextLink, buildCategoryPrevLink, buildCategoryCanonical, buildCategoryAlternates, buildProductAlternates, buildUniqueClassName, buildMagazineLinks, buildUniqueIdName };